import * as React from 'react';
import { useSelector } from 'react-redux';
import { NewbuildingEmptyReviewsStat, NewbuildingReviewsStat } from '../../components/NewbuildingReviewsStat';
import { getProductsData, getUser } from '../../selectors/analytics';
import { getBuilders, getFullUrl, getNewbuildingId, getReviewsStat } from '../../selectors/newbuilding';
import { trackNewbuildingReviewsAnalytic } from '../../utils/analytics/reviewsAnalytics';

export const NewbuildingReviewsStatContainer: React.FC = () => {
  const reviewStat = useSelector(getReviewsStat);
  const fullUrl = useSelector(getFullUrl);

  const user = useSelector(getUser);

  const builder = useSelector(getBuilders)[0] || null;
  const id = useSelector(getNewbuildingId);
  const products = [getProductsData(id, builder)];

  const page = {
    pageType: 'CardJK',
    siteType: 'desktop',
    extra: {
      type: 'review',
      rating: reviewStat?.rating,
    },
  };

  const trackingReviewLinkClick = React.useCallback(() => {
    trackNewbuildingReviewsAnalytic({
      action: 'Click_sopr',
      category: 'Card_JK',
      label: 'Rating',
      user,
      page,
      products,
    });
  }, [user]);

  if (!reviewStat?.reviewsCount || !fullUrl) {
    return <NewbuildingEmptyReviewsStat />;
  }

  return (
    <NewbuildingReviewsStat
      fullUrl={fullUrl}
      rating={reviewStat.rating}
      reviewsCountText={reviewStat.reviewsCountText}
      reviewLinkClick={trackingReviewLinkClick}
    />
  );
};
